import React, { useEffect } from 'react'
import { useNavigate } from "react-router-dom";

function Navber() {
	const navigate = useNavigate();
	const user = JSON.parse(localStorage.getItem("currentuser"));
	const admin =''



	const logout =()=>{
		localStorage.removeItem("currentuser");
		navigate("/login");
	}
  return (
		<div>
			<nav class="navbar navbar-expand-lg bg-body-tertiary">
				<div class="container-fluid">
					<a class="navbar-brand" href="/">
						Poly Hotel
					</a>
					<button
						class="navbar-toggler"
						type="button"
						data-bs-toggle="collapse"
						data-bs-target="#navbarNav"
						aria-controls="navbarNav"
						aria-expanded="false"
						aria-label="Toggle navigation">
						<span class="navbar-toggler-icon">
							<i class="fa-solid fa-bars" style={{ color: "#FFF" }}></i>
						</span>
					</button>
					<div class="collapse navbar-collapse" id="navbarNav">
						<ul class="navbar-nav">
							{user ? (
								<>
									<div class="dropdown">
										<button
											class="btn btn-secondary dropdown-toggle"
											type="button"
											data-bs-toggle="dropdown"
											aria-expanded="false">
											{user.name}
										</button>
										<ul class="dropdown-menu">
											<li>
												<a class="dropdown-item" href="/profile">
													Profile
												</a>
											</li>
											{user.isAdmin ? (
												<li>
													<a
														class="dropdown-item"
														href=""
														onClick={() => {
															navigate("/admin");
														}}>
														Admin
													</a>
												</li>
											) : (
												""
											)}

											<li>
												<a class="dropdown-item" href="#" onClick={logout}>
													Logout
												</a>
											</li>
										</ul>
									</div>
								</>
							) : (
								<>
									<li
										class="nav-item"
										onClick={() => {
											navigate("/register");
										}}>
										<a class="nav-link active" aria-current="page" href="#">
											Register
										</a>
									</li>
									<li
										class="nav-item"
										onClick={() => {
											navigate("/login");
										}}>
										<a class="nav-link" href="#">
											Login
										</a>
									</li>
								</>
							)}
						</ul>
					</div>
				</div>
			</nav>
		</div>
	);
}

export default Navber